export default "__VITE_ASSET__e7a12069__"